import React from "react";
import BaseComponent from "../../../BaseComponent.js";
import styled from "styled-components";
import nota from "../../../Global/nota.guidelines.json";

import NanoFlex from "../../../Global/NanoFlex.js";
import Type from "../../../Global/Typography.js";
import WrapperList from "../../../Nano/WrapperList.js";

const multiple = nota.global.multiple;

const StyledFormatTypeBlock = styled(NanoFlex)`
  background-color: ${nota.color.neutral.NeuFive};
  .listTopBarWrapper {
    padding: ${multiple + "px"};
    background-color: ${nota.color.neutral.NeuFive};
    min-width: 120px;
    max-width: 35%;
    h5 {
      font-size: 13px;
    }
    h3 {
      margin-top: ${multiple + "px"};
      text-transform: uppercase;
      color: ${nota.color.secondary.secAquaGreen};
    }
  }
  .noBorderWrapper {
    border: none;
    margin-bottom: 0;
    padding: ${multiple + "px"};
  }

  .columnsContainer {
    .columnWrapper {
      border-left: 1px solid ${nota.color.neutral.NeuThree};
      height: auto;
      .infoContainer {
        margin-bottom: ${multiple + "px"};
        margin-left: ${multiple * 2 + "px"};
        height: auto;
        .titleInfo {
          text-transform: uppercase;
        }
        &:last-child {
          margin-bottom: 0;
        }
      }
      &:first-child {
        border: none;
        .infoContainer {
          margin-left: 0;
        }
      }
    }
  }
  @media only screen and (max-width: 600px) {
    .columnsContainer {
      .columnWrapper {
        .infoContainer {
          margin-left: 8px;
        }
      }
    }
  }
`;

export class FormatTypeBlock extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  onClickSearch = (obj) => {
    return window.dispatchEvent(new CustomEvent("setSearchFrom", { detail: { menu: "SearchFromCard", filter: obj } }));
  };

  render() {
    return (
      <StyledFormatTypeBlock className="rowContainer formatWrapper" flexDirection={"row"}>
        <NanoFlex className="listTopBarWrapper" flexDirection={"column"} justifyContent={"center"} alignItems={"center"} alignContent={"center"}>
          <Type.h5>
            <b>{this.translation.card.formatType}</b>
          </Type.h5>
          <Type.h3>
            <b>{this.translation.geral.formatTypes[this.props.card.formatType?.toLowerCase()]}</b>
          </Type.h3>
        </NanoFlex>

        {(this.props.card.producedIn || this.props.card.developedIn || this.props.card.productionCompanies || this.props.card.distributors) && (
          <WrapperList simple className="noBorderWrapper">
            <NanoFlex className="columnsContainer" justifyContent={"flex-start"} alignItems={"stretch"}>
              {(this.props.card.producedIn || this.props.card.developedIn) && (
                <NanoFlex className="columnWrapper" flexDirection={"column"} justifyContent={"flex-start"} alignItems={"flex-start"}>
                  {/* PRODUCED IN */}
                  {this.props.card.producedIn && (
                    <NanoFlex className="infoContainer" flexDirection={"column"} justifyContent={"flex-start"} alignItems={"flex-start"}>
                      <Type.p className="titleInfo">{this.translation.card.producedIn}</Type.p>
                      {this.props.card.producedIn.map((item) => {
                        return (
                          <Type.p key={"ProducedIn_" + item.id} className="item clickableSearch" onClick={() => this.onClickSearch({ selectedProducedIn: [item.id] })}>
                            <b>{item.name}</b>
                          </Type.p>
                        );
                      })}
                    </NanoFlex>
                  )}

                  {/* DEVELOPED IN */}
                  {this.props.card.developedIn && (
                    <NanoFlex className="infoContainer" flexDirection={"column"} justifyContent={"flex-start"} alignItems={"flex-start"}>
                      <Type.p className="titleInfo">{this.translation.card.developedIn}</Type.p>
                      {this.props.card.developedIn.map((item) => {
                        return (
                          <Type.p key={"DevelopedIn_" + item.id} className="item clickableSearch" onClick={() => this.onClickSearch({ selectedDevelopedIn: [item.id] })}>
                            <b>{item.name}</b>
                          </Type.p>
                        );
                      })}
                    </NanoFlex>
                  )}
                </NanoFlex>
              )}

              {(this.props.card.productionCompanies || this.props.card.distributors) && (
                <NanoFlex className="columnWrapper" flexDirection={"column"} justifyContent={"flex-start"} alignItems={"flex-start"}>
                  {/* PRODUCTION COMPANY(S) */}
                  {this.props.card.productionCompanies && (
                    <NanoFlex className="infoContainer" flexDirection={"column"} justifyContent={"flex-start"} alignItems={"flex-start"}>
                      <Type.p className="titleInfo">{this.props.card.productionCompanies.split(" / ").length > 1 ? this.translation.card.productionCompanies : this.translation.card.productionCompany}</Type.p>
                      {this.props.card.productionCompanies.split(" / ").map((item) => {
                        return (
                          <Type.p key={"ProductionCompanies_" + item} className="item clickableSearch" onClick={() => this.onClickSearch({ selectedSearchTitles: ["PRODUCERS"], term: item })}>
                            <b>{item}</b>
                          </Type.p>
                        );
                      })}
                    </NanoFlex>
                  )}

                  {/* DISTRIBUTOR(S) */}
                  {this.props.card.distributors && (
                    <NanoFlex className="infoContainer" flexDirection={"column"} justifyContent={"flex-start"} alignItems={"flex-start"}>
                      <Type.p className="titleInfo">{this.translation.card.distributors}</Type.p>
                      {this.props.card.distributors.split(" / ").map((item) => {
                        return (
                          <Type.p key={"Distributors_" + item} className="item clickableSearch" onClick={() => this.onClickSearch({ selectedSearchTitles: ["DISTRIBUTORS"], term: item })}>
                            <b>{item}</b>
                          </Type.p>
                        );
                      })}
                    </NanoFlex>
                  )}
                </NanoFlex>
              )}
            </NanoFlex>
          </WrapperList>
        )}
      </StyledFormatTypeBlock>
    );
  }
}

//Set default props
FormatTypeBlock.defaultProps = {
  card: {},
};

export default FormatTypeBlock;

// --- // Documentation // --- //
/*
  import FormatTypeBlock from './../Partial/FormatTypeBlock.js';
  
  <FormatTypeBlock/>
  */
